export const defaultServiceConfig = {
  datadogRum: {
    site: 'datadoghq.com',
    service: 'lms-ui',
  },
} as const;
